import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "links",
  class: "links"
}
const _hoisted_2 = { class: "links__container" }
const _hoisted_3 = {
  href: "/Introduction/index.html",
  class: "links__cta"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Home.links")), 1),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("a", {
        href: "https://gitlab.com/josros",
        class: "links__pill glass-card"
      }, "Gitlab", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("a", {
        href: "https://medium.com/@jh.rossa",
        class: "links__pill glass-card"
      }, "Medium", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("a", {
        href: "https://www.linkedin.com/in/josef-rossa-213137115/",
        class: "links__pill glass-card"
      }, "LinkedIn", -1)),
      _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$t("Home.virtualIntro")), 1)
    ])
  ]))
}